import { MailStatus, FilterReasonCode } from "../../models/ISupportMail";

export const STATUS_META: Record<MailStatus, { label: string; color: string; bg: string; border: string }> = {
  TicketCreated:  { label: "Ticket Açıldı",     color: "#16a34a", bg: "#f0fdf4", border: "#bbf7d0" },
  AddedToTicket:  { label: "Ticket'a Eklendi",  color: "#2563eb", bg: "#eff6ff", border: "#bfdbfe" },
  Filtered:       { label: "Filtrelendi",       color: "#6b7280", bg: "#f9fafb", border: "#e5e7eb" },
  NotProcessed:   { label: "İşlenmedi",         color: "#6b7280", bg: "#f9fafb", border: "#e5e7eb" },
  Pending:        { label: "İşleniyor",         color: "#d97706", bg: "#fffbeb", border: "#fde68a" },
  Failed:         { label: "Hata",              color: "#dc2626", bg: "#fef2f2", border: "#fecaca" },
};

export const FILTER_REASON_LABEL: Record<FilterReasonCode, string> = {
  GmailCategory: "Gmail kategorisi",
  BulkHeader: "Toplu gönderim",
  AutoReply: "Otomatik cevap",
  BlockedDomain: "Engelli domain",
  BlockedAddress: "Engelli adres",
  BlockedSubject: "Engelli konu",
};
